<template>
    <div class="container">
        <div class="card item-hover mb-2">
            <div class="card-body px-2">
                <div class="card-body p-2 text-muted text-center">
                    <b>総ポイント</b>
                </div>
                <div class="card-body p-2 text-center text-success ">
                    <span class="point-num" @click="toPointInfo"><b>{{toLocaleString(getPoint.points)}}</b></span>&nbsp;
                    <span class="pt-2"><b>点</b></span>
                </div>
                <div class="card-body px-2 py-0 text-right text-danger ">
                    <span class="point-num" @click="toExchangeInfo"><b>{{toLocaleString(getPoint.changes)}}</b></span>&nbsp;
                    <span class="pt-2"><b>点[ex]</b></span>
                </div>
                <div class="card-body p-2">
                    <span>
                        <i class="far fa-lightbulb text-success"></i>
                        <small class="text-muted"> 1点={{getPoint.now_rate}}円 </small>&nbsp;
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        computed: {
            ...mapGetters(['getPoint'])
        },
        methods: {
            toPointInfo () {
                this.$router.push({name:'PointInfo'})
            },
            toExchangeInfo () {
                this.$store.dispatch('setRefreshArr', 'exchangeInfo')
                this.$store.dispatch('resetListObj')
                this.$router.push({name:'ExchangeInfo'})
            },
            toLocaleString (num) {
                return Number(num).toLocaleString()
            },
        }
    }
</script>

<style lang="stylus" scoped>
    .point-num
        font-size: 1.8rem;

</style>
